export type GamificationCredentials = {
  customer_token: string;
  partner_uuid: string;
  partner_secret: string;
  customer_code: string;
};

export type GamificationBalance = {
  balance: number;
  unauthorized?: boolean;
};

export type GamificationRewards = {
  balance: number;
  rewards: GamificationReward[];
};

type GamificationReward = {
  /** 20/08/2024 */
  date: string;
  mission: string;
  points: number;
};

export const rewardsFactory: GamificationRewards = {
  balance: 0,
  rewards: [],
};

export const balanceFactory: GamificationBalance = {
  balance: 0,
  unauthorized: false,
};
